<template>
    <section class="pop-form pop-sign-log third-register">
        <hgroup>
            <h2>{{ $t('common:thirdRegister.registerTitle') }}</h2>
            <p>
                {{ $t('common:thirdRegister.registerSubTitle') }}
            </p>
        </hgroup>
        <div class="pop-form-content">
            <div class="pop-form-benefits">
                <div
                    class="benefits-title"
                    v-if="benefitsTitle"
                    v-html="benefitsTitle"
                ></div>
                <ul class="benefits-list">
                    <li v-if="benefitsMarket" class="item">
                        <span class="iconfont icon-checked market"></span>
                        <div class="text" v-html="benefitsMarket"></div>
                    </li>
                    <li v-if="benefitsMoney" class="item">
                        <span class="iconfont icon-checked money"></span>
                        <div class="text" v-html="benefitsMoney"></div>
                    </li>
                    <li v-if="benefitsHomes" class="item">
                        <span class="iconfont icon-checked homes"></span>
                        <div class="text" v-html="benefitsHomes"></div>
                    </li>
                </ul>
            </div>
            <div class="pop-form-main">
                <v-form
                    :onSubmit="thirdRegisterSubmit"
                    :onSuccess="thirdRegisterSubmitSuccess"
                    :onError="thirdRegisterSumbitError"
                    ref="form"
                >
                    <div class="name">
                        <input
                            readonly
                            :value="fullname"
                            autocomplete="off"
                            type="text"
                            name="fullname"
                        />
                        <span class="checked">
                            <i class="iconfont icon-checked"></i>
                        </span>
                    </div>
                    <v-input
                        v-if="!email"
                        name="email"
                        type="email"
                        :placeholder="$t('common:enterEmailAddress') + '*'"
                        required
                        focus
                        clearable
                        :validateConfig="{
                            async: '/api-site/register/hasUser?account={value}',
                            'async-callback': hasUserCallBack,
                            'email-msg': $t('common:validate.emailInvalid2')
                        }"
                        :otherOption="{ cutting: 24 }"
                        @input="onTrackEmail(regType.email)"
                    ></v-input>
                    <div v-else class="email">
                        <input
                            readonly
                            :value="email"
                            autocomplete="off"
                            type="email"
                            name="email"
                        />
                        <span class="checked">
                            <i class="iconfont icon-checked"></i>
                        </span>
                    </div>
                    <v-input
                        class="phone"
                        name="phone"
                        type="tel"
                        clearable
                        :focus="!!email"
                        :placeholder="
                            $t('common:register.passwordPlaceholder1', {
                                infix: phoneRequired ? '*' : ''
                            })
                        "
                        :required="phoneRequired"
                        :validateConfig="{
                            async: '/api-site/phoneValidate?phoneNumber={value}',
                            'tel-msg': $t('common:validate.phoneInvalid2')
                        }"
                        @input="onTrackPhone(regType.phone)"
                    ></v-input>
                    <disclaimer :disclaimerUniqId="disclaimerUniqId" @updateChecked="updateChecked" class="pop-register-disclaimer" color="#505050" :btnText="$t('common:thirdRegister.submitText')" />
                    <div :class="{'submit':true, disabled:disclaimerSubmitDisabled}" :title="disclaimerSubmitDisabled ? $t('common:customDisclaimerTip'):''">
                        <input
                            type="submit"
                            :value="$t('common:thirdRegister.submitText')"
                        />
                    </div>
                    <p v-show="thirdPartErrorShow" class="mg-error">
                        {{ thirdPartErrorMsg }}
                    </p>
                </v-form>
            </div>
        </div>
    </section>
</template>

<script>
import vFormVue from '../../v-form.vue';
import vInputVue from '../../v-input.vue';
import track from '../third-register-track-mixins';

export default {
    mixins: [track],
    props: {
        options: {
            type: Object,
            default: () => ({})
        },
        fullname: {
            type: String,
            default: ''
        },
        email: {
            type: String,
            default: ''
        },
        phoneRequired: {
            type: Boolean,
            default: true
        },
        thirdPartErrorShow: {
            type: Boolean,
            default: false
        },
        thirdPartErrorMsg: {
            type: String,
            default: ''
        },
        thirdRegisterSubmit: Function,
        thirdRegisterSubmitSuccess: Function,
        thirdRegisterSumbitError: Function
    },
    computed: {
        benefitsTitle() {
            if (this.options.benefitsTitle === undefined) {
                return this.$t('common:register.registrationBenefit');
            } else {
                return this.options.benefitsTitle;
            }
        },
        benefitsMarket() {
            if (this.options.benefitsMarket === undefined) {
                return this.$t('common:register.benefit1');
            } else {
                return this.options.benefitsMarket;
            }
        },
        benefitsMoney() {
            if (this.options.benefitsMoney === undefined) {
                return this.$t('common:register.benefit2');
            } else {
                return this.options.benefitsMoney;
            }
        },
        benefitsHomes() {
            if (this.options.benefitsHomes === undefined) {
                return this.$t('common:register.benefit3');
            } else {
                return this.options.benefitsHomes;
            }
        }
    },
    components: {
        'v-form': vFormVue,
        'v-input': vInputVue
    }
};
</script>
